import { globalStore } from '@/assets/js/common/utils'
import {RGBELoader} from 'three/examples/jsm/loaders/RGBELoader.js'
import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader.js'
import {DRACOLoader} from 'three/examples/jsm/loaders/DRACOLoader.js'
let modelPath = (location.hostname === "localhost") ? '/assets/glb/' : '/sites/all/themes/oceanpark/glb/';
let imgPath = (location.hostname === "localhost") ? 'https://media.oceanpark.com.hk/files/s3fs-public/halloween2025/' : '/sites/all/themes/oceanpark/img/';
import THREE, { AnimationMixer, Scene, HemisphereLight, WebGLRenderer, PerspectiveCamera, Sprite, SpriteMaterial,
	PlaneGeometry, ImageUtils, MeshLambertMaterial, Mesh, DirectionalLight, AdditiveBlending, LoopRepeat,
	TextureLoader, PointLight, SpotLight, Color, PMREMGenerator, MeshBasicMaterial, DoubleSide, LoopOnce,
	Raycaster, Vector2, MeshStandardMaterial, BoxGeometry,
	CubeUVReflectionMapping, ACESFilmicToneMapping, Clock, Group } from 'three';
import gsap from "gsap";
import * as SkeletonUtils from 'three/addons/utils/SkeletonUtils.js';

export const Ring = () => {
  console.log("This is another exported function.");

  Alpine.data('ringComponent', () => ({
    store: globalStore,
	currentTrueIndex: 0,
	isClicking: false,
	isOpened: false,
	reseting: false,
	mixerArray: [] as any,
	myGroup: null as any,
	camera: null as any,
	animate: null as any,
	animation: null as any,
	bigAnimation: null as any,
	btnDrawAgain: {
      ['@click']() {
		this.drawAgain();
	  }
	},
	ringPanel: {
      [':class']() {
        return { "active" : this.isOpened };
	  }
	},
    ringComponent: {
      ['x-init']() {
		const _this = this;
        // @ts-ignore
        this.store = (this.$store as HomeStore).global;
        
		var camera:any, scene:any, renderer:any, group:any, 
		clock:any, light:any, smokeGeo:any, smokeParticles:any, delta:any;
		var mixers:any = [];
		init();
		const raycaster = new Raycaster();
		const pointer = new Vector2();
		const objs:any = [];

		function init() {
			const fullRotate = Math.round(Math.PI*2*10000)/10000;
			const myDiv:any = document.querySelector('.halloween-2025-ring');
			function onPointerClick( event:any ) {
				_this.isClicking = true;
				const mouseX = event.clientX - myDiv.getBoundingClientRect().left;
				const mouseY = event.clientY - myDiv.getBoundingClientRect().top;

				pointer.x = ( mouseX / myDiv.getBoundingClientRect().width ) * 2 - 1;
				pointer.y = - ( mouseY / myDiv.getBoundingClientRect().height ) * 2 + 1;
				raycaster.setFromCamera(pointer, camera);

				const intersects = raycaster.intersectObjects(objs, false); // Or specific meshes

				if (intersects.length > 0) {
					const clickedObject = intersects[0].object;
					if(typeof clickedObject.uuid === 'number' ){
						if(_this.currentTrueIndex==clickedObject.uuid){
							_this.isOpened = true;
							_this.unlock();
						}else if(!_this.isOpened){
							_this.currentTrueIndex = clickedObject.uuid;
							if(_this.myGroup){
								_this.ringRotate();
							}
							_this.resetRing();
						}
					}
				}
			}
			let storeX = 0;
			let groupX = 0;
			let isMouseDown = false;
			function onmousedown( event:any ) {
				if(_this.isOpened) return;
				storeX = event.clientX - myDiv.getBoundingClientRect().left;
				groupX = _this.myGroup.rotation.y;  
				isMouseDown = true;
			}
			function onmouseup( event:any ) {
				// console.log('up');
				isMouseDown = false;
				if(_this.isOpened || _this.reseting) return;
				_this.currentTrueIndex =  -Math.round(_this.myGroup.rotation.y/(Math.PI/3))%6;
				// console.log('first: ',_this.currentTrueIndex);
				if(_this.currentTrueIndex<0){
					_this.currentTrueIndex = 6+_this.currentTrueIndex;
				}
				// console.log('second: ',_this.currentTrueIndex);
				const targetRotation = Math.round(_this.myGroup.rotation.y/(Math.PI/3))*(Math.PI/3);
		
				_this.bigAnimation = gsap.to(_this.myGroup.rotation, { 
					duration: 1, 
					ease: "power2.out",
					y: targetRotation,
					onComplete: ()=>{
						// console.log('fin')
					}
				});
			}
			function onmouseMove( event:any ) {
				if(_this.isOpened) return;
				if(isMouseDown){
					const mouseX = event.clientX - myDiv.getBoundingClientRect().left;
					_this.myGroup.rotation.y = groupX + (mouseX-storeX)*-.01; 
				}
			}

			//TOUCH
			function ontouchstart( event:any ) {
				if(_this.isOpened) return;
				storeX = event.targetTouches[0].clientX;
				groupX = _this.myGroup.rotation.y;
				isMouseDown = true;
			}
			function ontouchmove( event:any ) {
				if(_this.isOpened) return;
				if(isMouseDown){
					const mouseX = event.targetTouches[0].clientX;
					_this.myGroup.rotation.y = groupX + (mouseX-storeX)*-.01; 
				}
			}

			myDiv.addEventListener( 'mousedown', onPointerClick );
			if('ontouchstart' in window){
				document.addEventListener( 'touchstart', ontouchstart );
				document.addEventListener( 'touchmove', ontouchmove );
				document.addEventListener( 'touchend', onmouseup );
			}else{
				document.addEventListener( 'mousedown', onmousedown );
				document.addEventListener( 'mouseup', onmouseup );
				document.addEventListener( 'mouseleave', onmouseup );
				document.addEventListener( 'mousemove', onmouseMove );
			}

			const contents:any = _this.$refs.contentRef.querySelectorAll('.halloween-2025-content-tab');
			clock = new Clock();

			renderer = new WebGLRenderer({ antialias: true });
			renderer.setSize( window.innerWidth, window.innerHeight );

			renderer.toneMapping = ACESFilmicToneMapping;
			renderer.toneMappingExposure = 1.0;

			scene = new Scene();
			scene.background = new Color(0x0f0f10);
		
			camera = new PerspectiveCamera( 50, window.innerWidth / window.innerHeight, 1, 10000 );
			_this.camera = camera;
			camera.position.z = 14;
			scene.add( camera );
			
			window.addEventListener('resize', onWindowResize, false);
		
			light = new DirectionalLight(0xffffff,2);
			light.position.set(5,5,5);
			scene.add(light);
			
			const pointLight = new PointLight(0x000000, 30);
			pointLight.position.set(0, 0, 0); // Center the point light at the origin
			scene.add(pointLight);

			// Create a new instance of TextureLoader
			const tloader = new TextureLoader();

			// Load the texture
			tloader.load(
				imgPath+'entrance/smoke-element.png',
				function (texture) {
					const smokeMaterial = new MeshLambertMaterial({color: 0x216076, map: texture, transparent: true});
					const smokeMaterial2 = new MeshLambertMaterial({color: 0x849095, map: texture, transparent: true});
					const smokeMaterial3 = new MeshLambertMaterial({color: 0x3a2121, map: texture, transparent: true});
					
					// var tempUnit = container.clientHeight / 3;
					smokeGeo = new PlaneGeometry(300,300);
					smokeParticles = [];
		
					for (var p = 0; p < 30; p++) {
						let mysmokeMaterial:any = smokeMaterial.clone();
						if(Math.round(Math.random()*3)==0){
							mysmokeMaterial = smokeMaterial2.clone();
						}else if(Math.round(Math.random()*3)==1){
							mysmokeMaterial = smokeMaterial3.clone();
						}
						var particle = new Mesh(smokeGeo,mysmokeMaterial);
						particle.position.set(Math.random()*600-300,Math.random()*50-160,Math.random()*800+200-1000);
						particle.rotation.z = Math.random() * 360;
						scene.add(particle);
						smokeParticles.push(particle);
					}
					loadGLB();
		
				},
				undefined, // Optional: onProgress callback
				function (err) {
					// Error during loading
					console.error('An error occurred while loading the texture:', err);
				}
			);
			let ring:any = document.querySelector('.halloween-2025-ring');
			if(ring){
				ring.appendChild( renderer.domElement );
			}
			
			const textureLoader = new TextureLoader();
   			const texture = textureLoader.load(imgPath+'entrance/centersmoke.png');
			const setting =  {
				map: texture,
				transparent:true,
				side: DoubleSide
			};
			const material = new MeshBasicMaterial(setting);
			const pgeometry = new PlaneGeometry( 12, 7 );
			const plane = new Mesh( pgeometry, material );
			scene.add( plane );

			function loadGLB(){
				//LOAD GLB
				group = new Group();
				_this.myGroup = group;

				scene.add( group );
				group.position.y = -2.2;
				group.position.z = -10;
				group.rotation.y = Math.PI;
				group.scale.x = 0;
				group.scale.y = 0;
				group.scale.z = 0;
				
				let radius = 5.5;
				if(window.innerWidth<=767){
					radius = 3.5;
					group.position.y = -1.8;
				}

				const loader = new GLTFLoader();
				const dracoLoader = new DRACOLoader();
				dracoLoader.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/');
				loader.setDRACOLoader( dracoLoader );

				const pmremGenerator = new PMREMGenerator(renderer);
				pmremGenerator.compileEquirectangularShader();
				new RGBELoader()
				.setPath( modelPath )
				.load( 'environment.hdr', function ( texture ) {
					const envMap = pmremGenerator.fromEquirectangular(texture).texture;
					scene.environment = envMap;
					loader.load(
						// resource URL
						modelPath+'box-new.glb',
						// called when the resource is loaded
						async function ( gltf ) {
							contents.forEach((e:any,i:any)=>{
								// let glb = gltf.scene.clone();
								let glb = SkeletonUtils.clone(gltf.scene);
								
								var boxGroup = new Group();
								var innerGroup = new Group();
								// glb.rotation.y = Math.PI/2;
								// boxGroup.position.x = 2*i;
								innerGroup.add( glb );
								boxGroup.add( innerGroup );
								group.add( boxGroup );

								const x = radius * Math.sin(i*60 * (Math.PI / 180));
								const z = radius * Math.cos(i*60 * (Math.PI / 180));
								boxGroup.position.x = x;
								boxGroup.position.z = z;

								boxGroup.rotation.y = ((i*60)) * (Math.PI / 180);

								glb.traverse(function (node:any) {
									if (node.material) {
										node.material.envMap = envMap;
										// node.material.roughness = 0.4;
										// node.material.metalness = .5;
										node.material.envMapIntensity = 2;
										node.material.needsUpdate = true;
									}
								})

								const loader = new TextureLoader();
								const texture = loader.load(e.dataset.img);
								const spriteMaterial = new SpriteMaterial({ map: texture });
								const sprite = new Sprite(spriteMaterial);
								sprite.scale.set(3.5/1.8, 6/1.8, 1);
								sprite.position.y = 1.8;
								innerGroup.add(sprite);

								const setting =  {
									color: 0xffffff,
									transparent:true,
									opacity:0
								};
								const material = new MeshStandardMaterial(setting);
								var geometry = new BoxGeometry( 2.1, 3.4, 2.1 );
								var box = new Mesh( geometry, material );
								box.position.y = 1.7;
								box.uuid = i;
								innerGroup.add(box);
								objs.push(box);

								let mixer:any;
								
								// use the following once the loader has loaded the model
								if (gltf.animations.length > 0) {
									mixer = new AnimationMixer( glb );
									gltf.animations.forEach( (clip:any) => {
									const action = mixer.clipAction( clip );
										action.play(); 
										action.paused = true;
									})
								}
								// mixers.push(mixer);
								mixers.push({
									mixer:mixer,
									animations:gltf.animations,
									innerGroup:innerGroup,
									sprite:sprite,
									glb:glb
								});
							})
							_this.mixerArray = mixers;

							function checkPosValid(){
								return (myDiv.getBoundingClientRect().top<Math.min(200,window.innerHeight/2) && myDiv.getBoundingClientRect().top>-(window.innerHeight/2));
							}
							function checkScroll(){
								if(checkPosValid()){
									_this.initRing();
									window.removeEventListener('scroll', checkScroll)
								}
							}
							if(checkPosValid()){
								setTimeout(()=>{
									_this.initRing();
								},2000)
							}else{
								window.addEventListener('scroll', checkScroll)
							}
						},
						// called while loading is progressing
						function ( xhr ) {
						},
						// called when loading has errors
						function ( error ) {
							console.log( 'An error happened' );
						}
					);
				})
			}
		}
		
		function animate() {
			delta = clock.getDelta();
			requestAnimationFrame( animate );
			evolveSmoke();
			
			for(let i=0; i<mixers.length; i++){
				if ( mixers[i].mixer ) {
					mixers[i].mixer.update( delta ); // Update the mixer with the elapsed time
				}
			}
			render();
		}
		_this.animate = animate;
		
		function evolveSmoke() {
			var sp = smokeParticles.length;
			while(sp--) {
				smokeParticles[sp].rotation.z += (delta * 0.2);
			}
		}

		function render() {
			renderer.render( scene, camera );
		}

		function onWindowResize() {
			camera.aspect = window.innerWidth / window.innerHeight;
			camera.updateProjectionMatrix();
			renderer.setSize(window.innerWidth, window.innerHeight);
		}
      },
    },
	isCurrentContent(myIndex:any){
		let nIndex:any = Number(myIndex.replace('box',''))-1;
		return nIndex==this.currentTrueIndex && this.isOpened;
	},
	ringBullet:{
      ['@click']() {
		this.bulletClick(this.$el.dataset.num);
	  }
	},
	bulletClick(myIndex:any){
		let nIndex:any = Number(myIndex.replace('box',''))-1;
		this.currentTrueIndex = nIndex;
		this.ringRotate();
	},
	ringRotate(myIndex:any){
		const fullRotate = Math.round(Math.PI*2*10000)/10000;

		const currentRotation = this.myGroup.rotation.y;
		const ringCount = Math.ceil(currentRotation/fullRotate);
		let targetRotation = ringCount*fullRotate-Math.PI*this.currentTrueIndex/3;
		if((targetRotation-currentRotation)>Math.PI){
			targetRotation-=fullRotate;
		}else if(-(targetRotation-currentRotation)>Math.PI){
			targetRotation+=fullRotate;
		}
		
		gsap.to(this.myGroup.rotation, { 
			duration: 1, 
			ease: "power2.out",
			y: targetRotation
		});
	},
	isCurrent(myIndex:any){
		let nIndex:any = Number(myIndex.replace('box',''))-1;
		return nIndex==this.currentTrueIndex;
	},
	initRing(){
		this.animate();
		gsap.to(this.myGroup.position, { 
			duration: 1, 
			ease: "power2.out",
			z: 0
		});
		gsap.to(this.myGroup.rotation, { 
			duration: 1, 
			ease: "power2.out",
			y: 0
		});
		gsap.to(this.myGroup.scale, { 
			duration: 1, 
			ease: "power2.out",
			x: 1,
			y: 1,
			z: 1
		});
	},
	drawAgain(){
		this.isOpened = false;
		this.resetRing();
	},
	resetRing(){
		const _this = this;
		_this.reseting = true;
		const mx:any = this.mixerArray;
		const ma:any = mx[this.currentTrueIndex];

		for(let i=0; i<mx.length; i++){
			if ( mx[i].innerGroup ) {
				gsap.to(mx[i].innerGroup.position, { 
					duration: 1, 
					ease: "power2.out",
					z: 0
				});
			}
		}
		this.animation = gsap.to(ma.innerGroup.position, { 
			duration: 1, 
			ease: "power2.out",
			x: 0,
			onComplete: ()=>{
				_this.reseting = false;
			}
		});
	},
	btnUnlockNow: {
      ['@click']() {
		this.unlock();
	  }
	},
	unlock(myIndex:any){
		const _this = this;

		// console.log(_this.currentTrueIndex);
		const mx:any = _this.mixerArray;
		const ma:any = mx[_this.currentTrueIndex];
		if(_this.animation){
			_this.animation.kill();
		}
		if(_this.bigAnimation){
			_this.bigAnimation.kill();
		}
		ma.animations.forEach( (clip:any) => {
			const action = ma.mixer.clipAction( clip );
			action.setLoop( LoopOnce );
			action.clampWhenFinished = true;
			action.paused = false;
			action.play(); 
		} );
		let ix = -1.6;
		if(window.innerWidth<768){
			ix = 0;
		}
		gsap.to(ma.glb.rotation, { 
			duration: 1, 
			ease: "circ.out",
			y: Math.PI/2
		});
		gsap.to(ma.innerGroup.position, { 
			duration: .6, 
			ease: "power2.out",
			x: ix,
			onComplete: ()=>{
				gsap.to(ma.glb.position, { 
					duration: 1, 
					ease: "elastic.out",
					y: -.4
				});
			}
		});
		setTimeout(()=>{
			gsap.to(ma.glb.position, { 
				duration: 1.6, 
				ease: "power2.out",
				y: -10,
				onComplete: ()=>{
					ma.glb.visible = false;
				}
			});
			gsap.to(ma.glb.rotation, { 
				duration: 1.6, 
				ease: "power2.out",
				x: .5,
				y: 1
			});
			gsap.to(ma.sprite.scale, { 
				duration: 1, 
				ease: "power2.out",
				x: 3.5/1.4,
				y: 6/1.4,
				z: 1
			});
			gsap.to(ma.sprite.position, { 
				duration: 1, 
				ease: "power2.out",
				y: 2.2,
			});
		},1300)
		gsap.to(_this.camera.position, { 
			duration: 1, 
			ease: "power2.out",
			z: 16
		});

		for(let i=0; i<mx.length; i++){
			if ( mx[i].innerGroup ) {
				gsap.to(mx[i].innerGroup.position, { 
					duration: 1, 
					ease: "power2.out",
					z: 2
				});
			}
		}
		_this.isOpened = true;
	}
  }));
};